import * as TYPES from './types';

export const fetchRapportageStatus = () => ({
  type: TYPES.FETCH_RAPPORTAGE_STATUS
});